module.exports = __webpack_public_path__ + "static/media/IMG_3480_sm.faf0bdd7.jpg";